import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { UserAdsEnum } from '@cai-services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EChartsOption } from 'echarts';
import { Router } from '@angular/router';
import { Campaign } from '../../core';
import { environment } from '../../environments';

@Component({
  selector: 'kt-search-popup',
  templateUrl: './search-popup.component.html',
  styleUrls: ['./search-popup.component.scss'],
  host: {
    '(document:click)': 'onClick($event)',
  },
  standalone: false,
})
export class SearchPopupComponent implements OnDestroy, OnInit {
  @Input() shouldShowSearchPopup: boolean;
  @Input() chartOption: EChartsOption;
  @Input() subTitle: string;
  @Input() title = 'While we connect to the airlines, have a look at:';
  @Input() campaignId: UserAdsEnum;
  @Input() isPromotion: boolean;
  @Input() isVideo: boolean;

  isChartRendering = true;
  isDestroyed: boolean;
  userAds = UserAdsEnum;
  adConfig: Campaign;

  constructor(
    private readonly modalService: NgbModal,
    private _eref: ElementRef,
    private readonly cdr: ChangeDetectorRef,
    private readonly router: Router,
  ) {}

  onChartInit(): void {
    this.isChartRendering = false;
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.isDestroyed = true;
  }

  ngOnInit() {
    this.isChartRendering = false;

    if (
      this.campaignId === UserAdsEnum.TRIAL_END ||
      this.campaignId === UserAdsEnum.TRIAL_START
    ) {
      this.adConfig = {
        enabled: true,
        campaignId: this.campaignId,
        title: 'test',
        subTitle: 'test',
        isPromotionAd: true,
        configurations: {
          staticSrc: `/assets/media/promotion/${this.campaignId?.toLowerCase()}.png`,
          href:
            this.campaignId === UserAdsEnum.TRIAL_START
              ? 'https://help.cargoai.co/en/articles/9234036-cargomart-pro-video-tutorial'
              : 'settings/office-settings#viewplans',
        },
      } as Campaign;
    } else {
      this.adConfig = environment?.chartsAndAds?.find(
        (adConfig) => adConfig.campaignId === this.campaignId,
      );
    }

    this.cdr.detectChanges();
  }

  close(): void {
    const searchModal = document.querySelector('.search-popup') as HTMLElement,
      target = document.querySelector('.search-popup-trigger') as HTMLElement;
    if (target) {
      const left = target.offsetLeft + 200,
        top = target.offsetTop - 300;
      searchModal.classList.add('animate');
      searchModal.style.transform =
        'translate(' + left + 'px,' + top + 'px) scale(0)';
      this.modalService.dismissAll();
    } else {
      this.modalService.dismissAll();
    }
  }

  onClick(event) {
    const targetButton = document.querySelector(
      '.search-popup-trigger',
    ) as HTMLElement;
    if (
      !this._eref.nativeElement?.contains(event.target) &&
      !targetButton?.contains(event.target)
    ) {
      this.close();
    }
  }

  handleImageClick(): void {
    if (!this.adConfig?.configurations?.href) {
      return;
    }
    if (this.campaignId === UserAdsEnum.TRIAL_END) {
      const targetUrl = this.adConfig?.configurations?.href;
      if (this.router.url === `/${targetUrl}`) {
        window.location.reload();
      } else {
        this.router.navigateByUrl(targetUrl);
      }
    } else {
      window.open(this.adConfig?.configurations?.href, '_blank', 'noopener');
    }
  }
}
